<template>
  <div class="manager-template" theme>
    <div id="manager-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'manager',
      parts: [
        {
          elem: '#manager-content',
          htmlFile: 'manager'
        }
      ]
    }
  }
}
</script>
